import { motion } from 'framer-motion'
import type { StepSee as StepSeeType } from '@/types/storytelling'

interface StepSeeProps {
  step: StepSeeType
  choiceMade: string
  onComplete: () => void
}

export function StepSee({ step, choiceMade, onComplete }: StepSeeProps) {
  const outcome = step.outcomes[choiceMade]
  if (!outcome) return null

  return (
    <div className="px-5 py-6">
      <p className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: 'var(--color-story-primary-light)' }}>See what happened</p>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6 }} className="rounded-2xl p-5 bg-white mb-4" style={{ border: '1px solid var(--color-story-border)' }}>
        <p className="text-sm leading-relaxed" style={{ color: 'var(--color-story-text)' }}>{outcome.narrative}</p>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.8 }} className="rounded-2xl p-5" style={{ background: 'linear-gradient(135deg, var(--color-story-bg), var(--color-story-bg-light))', border: '1px solid var(--color-story-border)' }}>
        <p className="text-sm italic leading-relaxed" style={{ color: 'var(--color-story-text)' }}>{outcome.reflection}</p>
      </motion.div>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.5 }} className="mt-6 text-center">
        <button onClick={onComplete} className="px-6 py-3 rounded-xl text-sm font-semibold text-white" style={{ background: 'linear-gradient(135deg, var(--color-story-primary), var(--color-story-primary-light))' }}>See the secret →</button>
      </motion.div>
    </div>
  )
}
